import { Component, OnInit } from '@angular/core';
import { SessionStorageService } from 'src/app/core/services/storage/session-storage.service';

/**
 * Static page to describe caa disclosure
 *
 * @export
 * @class CaaDisclosureComponent
 * @implements {OnInit}
 */
@Component({
	selector: 'op-caa-disclosure',
	templateUrl: './caa-disclosure.component.html',
	styleUrls: ['./caa-disclosure.component.scss']
})
export class CaaDisclosureComponent implements OnInit {
	/**
	 * The name of the organization that issued the disclosure
	 *
	 * @type {string}
	 * @memberof CaaDisclosureComponent
	 */
	issuingOrganization: string;

	constructor(private sessionStorageService: SessionStorageService) {}

	ngOnInit(): void {
		this.issuingOrganization = this.sessionStorageService.get('esign-originator');
	}
}
